export const MaterialRouting = [
  {
    path: "/tender/material/list",
    name: "tender-material-list",
    meta: { title: "投标报名费" },
    component: () =>
      import(/* webpackChunkName: "tender-material" */ "@/views/tender/material/list/index.vue"),
  },
  {
    hidden: true,
    path: "/tender/material/create",
    name: "tender-material-create",
    meta: { title: "新增投标报名费申请", comName: "TenderMaterialFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "tender-material" */ "@/views/tender/material/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/material/edit/:id",
    name: "tender-material-edit",
    meta: { title: "编辑投标报名费申请", comName: "TenderMaterialFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "tender-material" */ "@/views/tender/material/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/material/detail/:id",
    name: "tender-material-detail",
    meta: { title: "投标报名费申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "tender-material" */ "@/views/tender/material/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/material/flowPrint/:id",
    name: "tender-material-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(/* webpackChunkName: "tender-apply" */ "@/views/tender/material/flow-print/index.vue"),
  },
];
